<template>
	<span>
		<v-tooltip bottom color="black">
			<template #activator="{ on }">
				<v-icon color="#aaaaaa" size="20" class="material-icons ml-2" v-on="on">chat_bubble</v-icon>
			</template>
			<span>{{ justificativa }}</span>
		</v-tooltip>
	</span>
</template>

<script>
export default {
	name: 'justificativa-icone',
	props: {
		justificativa: {
			type: String,
			default: 'primary',
		},
	},
}
</script>

<style scoped></style>
